// extracted by mini-css-extract-plugin
export default {"container":"top-header-page_container__yrS3f","content":"top-header-page_content__AzEca","main":"top-header-page_main__7soox"};